export default "__VITE_ASSET__CYh_lSjD__"